import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportImpressionsData } from "../../../../models/FacilityReportData";
import { LineChart } from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";
import { TimeUnitSelect } from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart/TimeUnitSelect";
import { EditableAISummary } from "../EditableAISummary";

interface IImpressionsSectionProps {
  impressions?: FacilityReportImpressionsData;
  isDownloading: boolean;
  facilityReportId: string;
}

export const ImpressionsSection: React.FunctionComponent<
  IImpressionsSectionProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);
  const { impressions, isDownloading, facilityReportId } = props;

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">("day");

  useEffect(() => {
    if (impressions?.time_unit) {
      setTimeUnit(impressions.time_unit);
    }
  }, [impressions?.time_unit]);

  if (!impressions) {
    return null;
  }

  return (
    <div className="impressions-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-impressions-section"
      >
        <EditableAISummary
          title={t("impressionsSection.title")}
          summary={impressions.ai_summary}
          facilityReportId={facilityReportId}
          patchKey="impressions"
          isDownloading={isDownloading}
        >
          {!impressions.impressions_data && (
            <p className="no-data-message">{t("no_data")}</p>
          )}
        </EditableAISummary>
        {impressions.impressions_data && (
          <>
            {!isDownloading && (
              <div className="chart-controls-row">
                <TimeUnitSelect timeUnit={timeUnit} setTimeUnit={setTimeUnit} />
              </div>
            )}
            <LineChart
              chartDetailsData={impressions.impressions_data}
              usePrevYear={false}
              timeUnit={timeUnit}
              skipLabelTranslation={false}
              chartContainerId="facility-report-details-impressions-chart"
              hideCsvDownloadContainer={true}
            />
          </>
        )}
      </div>
    </div>
  );
};
